import file from "../Markdown/Statute.md";
import React from "react";
import MarkdownPage from "../Layout/MarkdownPage";

function Statute() {
    return (<MarkdownPage title='Regulamin' file={file} />);
}

export default Statute;